<div id="header" class="app-header" [attr.data-bs-theme]="">
  <div class="navbar-header">


    <a href="/" class="navbar-brand">
      <span class="navbar-logo col-4 col-sm-4 col-md-8"   >
        <img  src="assets/img/client/{{logo}}" alt="{{businessEntity}}">
      </span>
      <!-- <b>{{businessEntity}}</b>  -->
    </a>
    <button type="button" class="navbar-mobile-toggler" (click)="toggleAppSidebarMobile()"
      *ngIf="!this.appSettings.appSidebarNone">
      <span class="icon-bar"></span>
      <span class="icon-bar"></span>
      <span class="icon-bar"></span>
    </button>
    <button type="button" class="navbar-mobile-toggler" (click)="toggleAppTopMenuMobile()"
      *ngIf="this.appSettings.appTopMenu && this.appSettings.appSidebarNone">
      <span class="icon-bar"></span>
      <span class="icon-bar"></span>
      <span class="icon-bar"></span>
    </button>
  </div>
  <div class="navbar-nav">
    <div class="navbar-item navbar-form">
      <sa-company-info></sa-company-info>      
    </div>
    <!-- <div class="navbar-item navbar-form hide">
      <form action="" method="POST" name="search">
        <div class="form-group">
          <input type="text" class="form-control" placeholder="Enter keyword" />
          <button type="submit" class="btn btn-search"><i class="fa fa-search"></i></button>
        </div>
      </form>
    </div> -->

    <hub-notification></hub-notification>
    <div class="navbar-item navbar-user dropdown">
      <a href="javascript:;" class="navbar-link dropdown-toggle d-flex align-items-center" data-bs-toggle="dropdown">
        <div class="image image-icon bg-gray-800 text-gray-600">
          <i class="fa fa-user"></i>
        </div>
        <span>
          <span class="d-none d-md-inline">{{user.fullName }}</span>
          <b class="caret"></b>
        </span>
      </a>
      <div class="dropdown-menu dropdown-menu-end me-1">
        <a href="javascript:;" class="dropdown-item" (click)="editProfile()">Edit Profile</a>
        <!-- <a href="javascript:;" class="dropdown-item d-flex align-items-center">
          Inbox
          <span class="badge bg-danger rounded-pill ms-auto pb-4px">2</span>
        </a> -->
        
        <div class="dropdown-divider"></div>
        <a href="javascript:;" class="dropdown-item" (click)="showPopup()">Log Out</a>
      </div>
    </div>

  </div>
  <!--   
  <div class="navbar-nav">
    <div class="navbar-item navbar-form">
      <sa-company-info></sa-company-info>
    </div>
    <div class="navbar-header">
      <sa-collapse-menu></sa-collapse-menu>
    </div>
  </div> -->


  <!-- pulled right: nav area -->
  <!-- <div class="navbar-header pull-right">

    <ul id="mobile-profile-img" class="header-dropdown-list hidden-xs padding-5">
      <li class="">
        <a href="#" class="dropdown-toggle no-margin userdropdown" data-toggle="dropdown">
          <img src="assets/img/avatars/sunny.png" alt="Mudassir Hussain" class="online" />
        </a>
        <ul class="dropdown-menu pull-right">
          <li>
            <a (click)="(null)" class="padding-10 padding-top-0 padding-bottom-0"><i class="fa fa-cog"></i> Setting</a>
          </li>
          <li class="divider"></li>
          <li>
            <a routerLink="/app-views/profile" class="padding-10 padding-top-0 padding-bottom-0"> <i
                class="fa fa-user"></i>
              <u>P</u>rofile</a>
          </li>
          <li class="divider"></li>
          <li>
            <a (click)="(null)" class="padding-10 padding-top-0 padding-bottom-0" data-action="toggleShortcut"><i
                class="fa fa-arrow-down"></i> <u>S</u>hortcut</a>
          </li>
          <li class="divider"></li>
          <li>
            <a (click)="(null)" class="padding-10 padding-top-0 padding-bottom-0" data-action="launchFullscreen"><i
                class="fa fa-arrows-alt"></i> Full <u>S</u>creen</a>
          </li>
          <li class="divider"></li>
          <li>
            <a routerLink="/auth/login" class="padding-10 padding-top-5 padding-bottom-5" data-action="userLogout"><i
                class="fa fa-sign-out fa-lg"></i> <strong><u>L</u>ogout</strong></a>
          </li>
        </ul>
      </li>
    </ul>

    <sa-logout></sa-logout>
    <div id="search-mobile" class="btn-header transparent pull-right">
      <span> <a (click)="toggleSearchMobile()" title="Search"><i class="fa fa-search"></i></a> </span>
    </div>
    <form #searchForm="ngForm" (ngSubmit)="onSubmit()" class="header-search pull-right hidden">
      <input id="search-fld" type="text" name="param" required placeholder="Find reports and more">
      <button type="submit">
        <i class="fa fa-search"></i>
      </button>
      <a id="cancel-search-js" (click)="toggleSearchMobile()" title="Cancel Search"><i class="fa fa-times"></i></a>
    </form>

    <sa-full-screen></sa-full-screen>
 

    <button class="btn btn-default btn-header margin-top-10 pull-right" (click)="showSupportInfo()"><i
        class="fa fa-support"></i> Technical Support</button>

  </div> -->

</div>
